import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { TimesheetsOverviewComponent } from './timesheets-overview/timesheets-overview.component';

export const routes: Routes = [
    { path: '', redirectTo: 'overview', pathMatch: 'full' },
    { path: 'overview', component: TimesheetsOverviewComponent },
];

export const routing: ModuleWithProviders<any> = RouterModule.forChild(routes);
